import React,{useState,useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getVideoProductCategories, getProductCategoriesDataClear, getSubProductCategoriesDataClear } from '../../redux/courses/actions';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import {
  SessionKeys,
} from "../../utils/AppUtils";


export default function VideoCategoryListingSection() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authBroker = useSelector((state) => state.auth.authBroker);
    const [isLoading, setIsLoading] = useState(false);
    const productCategoriesData = useSelector(
      (state) => state.courses.videoProductCategories
    );

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const providerId = params.get('provider_id');
    console.log("providerId",providerId);
  
    const [courseCategories, setCourseCategories] = useState([]);
  
    useEffect(()=>{
      dispatch(getSubProductCategoriesDataClear());
          dispatch(getProductCategoriesDataClear());
    },[])
  
    useEffect(() => {
      if (!_.isEmpty(authBroker)) {
        setIsLoading(true)
        dispatch(
          getVideoProductCategories({
            module: "getProductCategoryFromWoo",
            brokerId: authBroker.payload.user.company_id,
            type:'videos',
            provider_id : providerId ? providerId : '',
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          })
        );
      }
    }, [authBroker])
  
    useEffect(() => {
      // console.log("product categories", productCategoriesData, courseCategoriesDataBroker);
      if (
        !_.isEmpty(productCategoriesData)
      ) {setIsLoading(false)
  
        let categoryArray = [];
        if (
          productCategoriesData.status === "success"
        ) {
          if (productCategoriesData?.payload?.length > 0) {
            categoryArray = [...categoryArray, ...productCategoriesData.payload];
          }
          categoryArray = _.sortBy(categoryArray, 'categoryId')
          console.log(categoryArray)
          setCourseCategories(categoryArray);
        }
  
  
      }
    }, [productCategoriesData]);

  return (
    <section className='my-credit-points course-category-page'>
    <div className='container'>
      <div className='row'>
        <div className='col-md-12'>
          <div className="events_banner">
            <p className="label-heading_events mb-4">Categories</p>
          </div>
        </div>
      </div>
      <div className='row mt-3'>
    
        {courseCategories?.map((item, index) => {
          return <div className='col-md-6 col-lg-4 col-xl-3 col-12 mb-4 cat-broker-box'>
    
          {item.image ? <div className='catbox cursor-pointer' style={{
                backgroundImage: `url(${item.image})`
              }}
                onClick={() => {
                  navigate( providerId ? `/video-listing?catId=${item.categoryId}&providerId=${providerId}` : `/video-listing?catId=${item.categoryId}`);
                }}>
                <div className='cat-overlay'>
                  <div className='cat-title-course'>
                    {item?.categoryName}
                  </div>
                </div>
              </div> 
              :
                <div className='catbox cursor-pointer without-img-course' style={{backgroundColor: '#d9d9d9'}}
                  onClick={() => {
                    navigate( providerId ? `/video-listing?catId=${item.categoryId}&providerId=${providerId}` : `/video-listing?catId=${item.categoryId}`);
                  }}>
                  <div className='cat-overlay'>
                    <div className='cat-title-course'>
                      {item?.categoryName}
                    </div>
                  </div>
                </div>}
          </div>
        })
        }
    
      </div>
    </div>
    </section>
  )
}



